// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"120":"7d4e2150","359":"3d18e89b"}[chunkId] + ".chunk.css";
};